// extracted by mini-css-extract-plugin
export default {"root":"Quote__root--bw5HF","footer":"Quote__footer--RisEo","right":"Quote__right--zXQ5J","total":"Quote__total--CuO6R"};